var map = {
	"./AkEval.jpg": 47369,
	"./DeloStud.jpg": 16419,
	"./Kazalniki.jpg": 7673,
	"./RaziskRazvoj.jpg": 28505,
	"./UL_logo-RGB_barv.png": 76468,
	"./UporabZnanj.jpg": 23361,
	"./finances.jpg": 24802,
	"./izobDejav.jpg": 97649,
	"./logoUL.jpg": 56225,
	"./logoUL1.jpg": 54688,
	"./poslo.jpg": 59962,
	"./pp_clanstvo.jpg": 99412,
	"./pp_razvojni_cilji.jpg": 91897,
	"./pp_ukrepi.jpg": 90890,
	"./qualityAssurance.jpg": 57197,
	"./umet.jpg": 16250,
	"./wp_izobrazevanje.jpg": 67149,
	"./wp_kazalniki.jpg": 28433,
	"./wp_poslovanje.jpg": 91684,
	"./wp_prenos_znanja.jpg": 34501,
	"./wp_raziskovanje.jpg": 5508,
	"./wp_sistem_kakovosti.jpg": 8078,
	"./wp_ustvarjalne_razmere.jpg": 98259
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 28683;